angular.
module("dx.webapp.accessibility").
component("dxAccessibilityFlags", {
	templateUrl: "tmpl/accessibility/accessibility-flags-directive.html",
	controller: "DxAccessibilityFlagsController",
	controllerAs: "vm",
	bindings: {
		displayMode: "<",
		accessibilityFlags: "<",
		studentName: "<",
	},
});
